"use client";

import React from "react";
import { motion } from "motion/react";
import { Zap, Shield, Clock, Heart, Target, Award } from "lucide-react";

const benefits = [
  {
    icon: Zap,
    title: "High Performance",
    description: "Lightning-fast load times and smooth interactions that keep users engaged and improve SEO rankings.",
    color: "text-violet-400",
    bg: "bg-violet-500/10",
  },
  {
    icon: Shield,
    title: "Secure by Design",
    description: "Implementing industry-standard security practices and robust authentication to protect your data.",
    color: "text-fuchsia-400",
    bg: "bg-fuchsia-500/10",
  },
  {
    icon: Clock,
    title: "Reliable Delivery",
    description: "Clear communication and strict adherence to deadlines. I value your time as much as my own.",
    color: "text-cyan-400",
    bg: "bg-cyan-500/10",
  },
  {
    icon: Target,
    title: "Business Focused",
    description: "I don't just write code; I build solutions that solve real business problems and drive growth.",
    color: "text-emerald-400",
    bg: "bg-emerald-500/10",
  },
  {
    icon: Award,
    title: "Premium Quality",
    description: "Attention to detail in every line of code and every pixel of the UI. Excellence is my standard.",
    color: "text-orange-400",
    bg: "bg-orange-500/10",
  },
  {
    icon: Heart,
    title: "Ongoing Support",
    description: "I'm a long-term partner for your digital journey, providing support and updates as you scale.",
    color: "text-pink-400",
    bg: "bg-pink-500/10",
  },
];

export function WhyChooseUs() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {benefits.map((benefit, index) => (
        <motion.div
          key={benefit.title}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: index * 0.1 }}
          className="group relative p-10 bg-neutral-900/40 backdrop-blur-md border border-neutral-800/50 rounded-[2.5rem] hover:border-white/20 transition-all duration-500 overflow-hidden"
        >
          <div className={`absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700`} />
          
          <div className="relative z-10">
            <div className={`mb-8 p-5 ${benefit.bg} border border-white/5 rounded-2xl w-fit group-hover:scale-110 transition-transform duration-500`}>
              <benefit.icon className={benefit.color} size={32} />
            </div>
            <h3 className="text-2xl font-black mb-4 uppercase tracking-tight text-white group-hover:text-white transition-colors">
              {benefit.title}
            </h3>
            <p className="text-neutral-500 text-sm md:text-base leading-relaxed font-medium group-hover:text-neutral-300 transition-colors">
              {benefit.description}
            </p>
          </div>
        </motion.div>
      ))}
    </div>
  );
}